import Header from "components/Common/Header/Header";
import React, { useEffect } from "react";
import PatientsListBody from "components/ClinicalManagement/Patients/PatientsListBody";

const Patients = () => {
  useEffect(() => {
    document.title = "Patients";
  }, []);

  return (
    <main id="app">
      {/* ---- common header ---- */}
      <Header moduleName="clinicalmanagement" />
      <PatientsListBody />
    </main>
  );
};

export default Patients;
